import React from "react";
import {getHumanDuration} from "../../../../../common/src";

export default ({currentTime, duration, hasDvr = false, hasLive = false, isLive = false}) => {
    const className = 'stream-player-controls-status';

    let containerClassName = className;
    if (hasLive) {
        containerClassName += ` ${className}-hasLive`;
    }
    if (isLive) {
        containerClassName += ` ${className}-isLive`;
    }

    return (
        <div className={containerClassName}>
            {hasDvr
                ? <span className={className + '-currentTime'}>{getHumanDuration(Math.floor(currentTime), true)}</span>
                : <span className={className + '-currentTime'}>{getHumanDuration(Math.floor(duration), true)}</span>
            }
            {!isNaN(duration) && hasDvr && !isLive && <>
                <span className={className + '-spacer'}> / </span>
                <span className={className + '-duration'}>{getHumanDuration(Math.floor(duration), true)}</span>
            </>}
        </div>
    )
}
